/**
 * Constants for MFACodeContainer component
 */

/**
 * Wait period in seconds before resend link becomes available
 */
export const MFA_WAIT_SECONDS = 30;

/**
 * Login MFA UI duration (matches okta.proxy 5-minute client login anchor)
 */
export const LOGIN_MFA_EXPIRATION_MINUTES = 5;

/**
 * OTP expiration — email factor for registration and recovery flows (matches notification copy)
 */
export const EMAIL_OTP_EXPIRATION_MINUTES = 10;

/**
 * OTP expiration — SMS/phone factor for registration and recovery flows (matches notification copy)
 */
export const SMS_OTP_EXPIRATION_MINUTES = 5;

export function getOtpExpirationMinutes(factorType?: string): number {
  const normalized = factorType?.toLowerCase() ?? "email";
  if (normalized === "sms" || normalized === "phone") {
    return SMS_OTP_EXPIRATION_MINUTES;
  }
  return EMAIL_OTP_EXPIRATION_MINUTES;
}

export function getOtpExpiresAtMs(factorType?: string, now = Date.now()): number {
  return now + getOtpExpirationMinutes(factorType) * 60_000;
}
